var map = {
	"./burger.jpg": 984,
	"./eggs benedict.jpg": 164,
	"./pizza.jpg": 417,
	"./salad.jpg": 765,
	"./sushi.jpg": 879,
	"./taco.jpg": 895,
	"./tiramisu.jpg": 381
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 477;